// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Q0A_U","buttons":"Footer_buttons__1Fq08"};